import React, { useEffect, useState } from "react";
import "../../../App.css";
import { Link, useLocation } from "react-router-dom";
import { Tooltip, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { selectConnectedServices, syncPlmConnections } from "../../../redux/plmHub/plmHubSlice";
import { fetchDriveConnectionStatus, selectDriveAvailable } from "../../../redux/googleDrive/googleDriveSlice";
import {
  FaInstagram,
  FaFileAlt,
  FaRocketchat,
  FaEnvelope,
  FaHouseUser,
  FaCaretLeft,
  FaCaretDown,
  FaTiktok,
  FaFileSignature,
  FaQuestionCircle,
  FaCreditCard,
  FaGoogle,
  FaPhotoVideo,
  FaHistory,
  FaBolt,
  FaRobot,
  FaCoins,
  FaMagic,
  FaTachometerAlt,
  FaPlug,
  FaPenFancy,
  FaImages,
  FaCalendarAlt,
  FaMedal,
  FaReceipt,
  FaWallet,
  FaGem,
  FaStar,
  FaTrophy,
  FaCheckCircle,
  FaListAlt,
  FaGoogleDrive,
} from "react-icons/fa";

import { IoSettings } from "react-icons/io5";
import ProjectWlogo from "../../../Utils/Images/PROJECT-W-LOGO 500X500.png";
const { Text } = Typography;

// Google features and the PLM Hub service each one needs.
const GOOGLE_LINKS = [
  { to: "/mail", label: "Gmail", service: "gmail", Icon: FaEnvelope },
  { to: "/draft", label: "Draft Emails", service: "gmail", Icon: FaPenFancy },
  { to: "/googlephotos", label: "Google Photos", service: "google_photos", Icon: FaImages },
  { to: "/googleevents", label: "Calendar Events", service: "google_calendar", Icon: FaCalendarAlt },
];

const Sidebar = ({ HandleToggle }) => {
  const pathName = useLocation();
  const dispatch = useDispatch();
  const connectedServices = useSelector(selectConnectedServices);
  // Drive is sandbox-gated: the link only shows when the backend exposes
  // services.drive for this account.
  const driveAvailable = useSelector(selectDriveAvailable);

  useEffect(() => {
    dispatch(syncPlmConnections());
    dispatch(fetchDriveConnectionStatus());
  }, [dispatch]);

  // const [isProjectWOpen, setIsProjectWOpen] = useState(false);
  const [isProjectWOpentiktok, setIsProjectWOpenTikTok] = useState(false);
  const [isProjectWOpenGoogle, setIsProjectWOpenGoogle] = useState(false);
  const [isProjectWOpenSubscription, setIsProjectWOpenSubscription] = useState(false);
  const [isProjectWOpenNFT, setIsProjectWOpenNFT] = useState(false);
  const [weePointsDropdown, setWeePointsDropdown] = useState(false);

  // const toggleProjectWMenu = () => {
  //   setIsProjectWOpen(!isProjectWOpen);
  // };

  const toggleProjectWMenuTiktok = () => {
    setIsProjectWOpenTikTok(!isProjectWOpentiktok);
  };
  const toggleProjectWMenuWeePoints = () => {
    setWeePointsDropdown(!weePointsDropdown);
  };

  const toggleProjectWMenuNFT = () => {
    setIsProjectWOpenNFT(!isProjectWOpenNFT);
  };

  const toggleProjectWMenuGoogle = () => {
    setIsProjectWOpenGoogle(!isProjectWOpenGoogle);
  };

  const toggleProjectWMenuSubscription = () => {
    setIsProjectWOpenSubscription(!isProjectWOpenSubscription);
  };

  return (
    <>
      <div className="side-bar">
        <a className="abs-bk" onClick={HandleToggle}>
          <FaCaretLeft className="icon" />
        </a>
        <div className="logo-sec">
          <Link to="/dashboard">
            <img className="w-100 logo-top" src="images/logo.png" alt="" />
            <h1
              style={{
                color: "white",
                textAlign: "center",
                fontFamily: "serif",
                fontWeight: "600",
              }}
            >
              <img src={ProjectWlogo} alt="Logo" className="logo" />
            </h1>
          </Link>
        </div>
        <div className="link-div">
          <ul className="link-ul">
            <li>
              <Link to="/dashboard" className={`sidebar-link ${pathName.pathname === "/home" ? "active" : ""}`} title="Dashboard">
                <FaTachometerAlt className="icons-svg" />
                <Text> Dashboard</Text>
              </Link>
            </li>
            <li>
              <a onClick={toggleProjectWMenuGoogle} className={`sidebar-link ${pathName.pathname.includes("/setting") ? "active" : ""}`} title="Google">
                <FaGoogle className="icons-svg" />
                <Text> Google</Text>

                <FaCaretDown className="submenu-caret" />
              </a>
              {isProjectWOpenGoogle && (
                <ul className="submenu">
                  <li>
                    {/* <Link to="/setting" className={`sidebar-link ${pathName.pathname === "/setting" ? "active" : ""}`} title="Setting">
                      <IoSettings className="icons-svg" />
                      <Text> Setting</Text>
                    </Link> */}
                  </li>
                      <li>
              <Link to="/plm-hub" className={`sidebar-link ${pathName.pathname === "/plm-hub" ? "active" : ""}`} title="PLM Hub">
                <FaPlug className="icons-svg" />
                <Text>Connected Services</Text>
              </Link>
            </li>
                  {GOOGLE_LINKS.map(({ to, label, service, Icon }) => (
                    <li key={to}>
                      {connectedServices[service] ? (
                        <Link to={to} className={`sidebar-link ${pathName.pathname === to ? "active" : ""}`} title={label}>
                          <Icon className="icons-svg" />
                          <Text> {label}</Text>
                        </Link>
                      ) : (
                        <Tooltip title={`Connect ${service} under Connected Services to use this`} placement="right">
                          <span className="sidebar-link" style={{ opacity: 0.45, cursor: "not-allowed" }} aria-disabled="true">
                            <Icon className="icons-svg" />
                            <Text> {label}</Text>
                          </span>
                        </Tooltip>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          
            {driveAvailable && (
              <li>
                <Link to="/google-drive" className={`sidebar-link ${pathName.pathname === "/google-drive" ? "active" : ""}`} title="Google Drive">
                  <FaGoogleDrive className="icons-svg" />
                  <Text> Google Drive</Text>
                </Link>
              </li>
            )}

            <li>
              <Link to="/getallbadges" className={`sidebar-link ${pathName.pathname === "/getallbadges" ? "active" : ""}`} title="Badges">
                <FaMedal className="icons-svg" />
                <Text> My Badges</Text>
              </Link>
            </li>
{/* 
               <li>
              <Link
                to="/dream-machine/create"
                className={`sidebar-link ${pathName.pathname.includes("/dream-machine") ? "active" : ""}`}
                title="Dream Machine"
              >
                <FaMagic className="icons-svg" />
                <Text>Dream Machine</Text>
              </Link>
            </li> */}
            <li>
              <Link to="/credittransactions" className={`sidebar-link ${pathName.pathname === "/credittransactions" ? "active" : ""}`} title="Credits transactions">
                <FaReceipt className="icons-svg" />
                <Text>AI Credits</Text>
              </Link>
            </li>
          
             <li>
              <a onClick={toggleProjectWMenuNFT} className={`sidebar-link ${pathName.pathname.includes("/nftmint") ? "active" : ""}`} title="Solana Nft">
                <FaWallet className="icons-svg" />
                <Text>Solana Wallet</Text>
                <FaCaretDown className="submenu-caret" />
              </a>
              {isProjectWOpenNFT && (
                <ul className="submenu">
                    <li>
                    <Link to="/transaction" className={`sidebar-link ${pathName.pathname === "/transaction" ? "active" : ""}`} title="Transaction History">
                      <FaHistory className="icons-svg" />
                      <Text>Transaction History</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/getrequests" className={`sidebar-link ${pathName.pathname === "/getrequests" ? "active" : ""}`} title="PRW & SOL Requests">
                      <FaCoins className="icons-svg" />
                      <Text>PRW & SOL Requests</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/nftmint" className={`sidebar-link ${pathName.pathname === "/nftmint" ? "active" : ""}`} title="Nft's">
                      <FaGem className="icons-svg" />
                      <Text>My NFTs</Text>
                    </Link>
                  </li>
                
                </ul>
              )}
            </li>
            <li>
              <a onClick={toggleProjectWMenuWeePoints} className={`sidebar-link ${pathName.pathname.includes("/weepoint-rewards") ? "active" : ""}`} title="WeePoints">
                <FaStar className="icons-svg" />
                <Text> WeePoints</Text>

                <FaCaretDown className="submenu-caret" />
              </a>
              {weePointsDropdown && (
                <ul className="submenu">
                  <li>
                    <Link to="/weepoint-rewards" className={`sidebar-link ${pathName.pathname === "/weepoint-rewards" ? "active" : ""}`} title="Wee Point Rewards">
                      {/* <FaQuestionCircle className="icons-svg" /> */}
                      <img src={ProjectWlogo} alt="Logo" className="logo" style={{ height: "20px", width: "20px" }} />
                      <Text> Wee Point Rewards</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/leaderboard" className={`sidebar-link ${pathName.pathname === "/leaderboard" ? "active" : ""}`} title="LeaderBoard">
                      <FaTrophy className="icons-svg" />
                      <Text> Leaderboard</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/weepointshistory" className={`sidebar-link ${pathName.pathname === "/weepointshistory" ? "active" : ""}`} title="WeePointsHistory">
                      <FaHistory className="icons-svg" />
                      <Text> Points History</Text>
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            

            {/* <li>
              <Link to="/referral" className={`sidebar-link ${pathName.pathname === "/referral" ? "active" : ""}`} title="Referral">
                <FaUserFriends className="icons-svg" />
                <Text> Referral</Text>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/socialwall" className={`sidebar-link ${pathName.pathname === "/socialwall" ? "active" : ""}`} title="socialwall">
                <FaHouseUser className="icons-svg" />
                <Text> SocialWall</Text>
              </Link>
            </li> */}

            {/* <li>
              <Link to="/gmail" className={`sidebar-link ${pathName.pathname === "/gmail" ? "active" : ""}`} title="Gmail">
                <FaEnvelope className="icons-svg" />
                Gmail
              </Link>
            </li> */}

            {/* <li> */}
            {/* <a onClick={toggleProjectWMenu} className={pathName.pathname.includes("/Chatai") ? "active" : ""} title="ProjectW(AI)">
                <FaRocketchat className="icons-svg" />
                ProjectW(AI)
                <FaCaretDown className="submenu-caret" />
              </a> */}
            {/* {isProjectWOpen && (
                <ul className="submenu"> */}
            {/* <li>
              <Link to="/Chatai" className={`sidebar-link ${pathName.pathname === "/Chatai" ? "active" : ""}`} title="ProjectW(AI)">
                <FaRocketchat className="icons-svg" />
                <Text>ProjectW(AI)</Text>
              </Link>
            </li> */}
         

            <li>
              <Link to="/gemini" className={`sidebar-link ${pathName.pathname === "/gemini" ? "active" : ""}`} title="Gemini">
                <FaRobot className="icons-svg" />
                <Text>Gemini</Text>
              </Link>
              {/* </li> */}

              {/* <li>
                    <Link to="/Chatbot" className={pathName.pathname === "/Chatbot" ? "active" : ""}>
                    <FaRocketchat className="icons-svg" />
                    ChatBot
                    </Link>
                  </li> */}
              {/* </ul>
              )} */}
            </li>

            <li>
              <Link to="/instagram" className={`sidebar-link ${pathName.pathname === "/instagram" ? "active" : ""}`} title="Instagram">
                <FaInstagram className="icons-svg" />
                <Text>Instagram</Text>
              </Link>
            </li>

            {/* <li>
              <Link to="/tiktok" className={pathName.pathname === "/tiktok" ? "active" : ""} title="Continue with TikTok">
                <FaTiktok className="icons-svg" />
                TikTok
              </Link>
            </li> */}

            <li>
              <a onClick={toggleProjectWMenuTiktok} className={`sidebar-link ${pathName.pathname.includes("/tiktok") ? "active" : ""}`} title="TikTok">
                <FaTiktok className="icons-svg" />
                <Text> TikTok</Text>

                <FaCaretDown className="submenu-caret" />
              </a>
              {isProjectWOpentiktok && (
                <ul className="submenu">
                  <li>
                    <Link to="/tiktok" className={`sidebar-link ${pathName.pathname === "/tiktok" ? "active" : ""}`} title="Continue with TikTok">
                      <FaTiktok className="icons-svg" />
                      <Text> Continue with Tiktok</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/tiktokuserprofile" className={`sidebar-link ${pathName.pathname === "/tiktokuserprofile" ? "active" : ""}`} title="Profile">
                      <FaTiktok className="icons-svg" />
                      <Text> Profile</Text>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a onClick={toggleProjectWMenuSubscription} className={`sidebar-link ${pathName.pathname.includes("/Subscription") ? "active" : ""}`} title="Subscription">
                <FaCreditCard className="icons-svg" />
                <Text> Subscription</Text>

                <FaCaretDown className="submenu-caret" />
              </a>
              {isProjectWOpenSubscription && (
                <ul className="submenu">
                  {/* <li>
                    <Link to="/Subscription" className={`sidebar-link ${pathName.pathname === "/Subscription" ? "active" : ""}`} title="Subscription">
                      <FaCreditCard className="icons-svg" />

                      <Text> Subscription</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/activeplan" className={`sidebar-link ${pathName.pathname === "/activeplan" ? "active" : ""}`} title="Active Plan">
                      <FaCheckCircle className="icons-svg" />
                      <Text> Active Plan</Text>
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/plans" className={`sidebar-link ${pathName.pathname === "/plans" ? "active" : ""}`} title="Plans">
                      <FaListAlt className="icons-svg" />
                      <Text>Browse Plans</Text>
                    </Link>
                  </li>
                  <li>
                    <Link to="/planhistory" className={`sidebar-link ${pathName.pathname === "/planhistory" ? "active" : ""}`} title="Plan History">
                      <FaHistory className="icons-svg" />
                      <Text>Plan History</Text>
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {/* <li>
              <Link to="/transaction" className={`sidebar-link ${pathName.pathname === "/transaction" ? "active" : ""}`} title="Transaction History">
                <FaHistory  className="icons-svg" />
                <Text>  Transaction History</Text>
              
              </Link>
            </li>
            <li>
              <Link to="/nftmint" className={`sidebar-link ${pathName.pathname === "/nftmint" ? "active" : ""}`} title="Nft">
                <FaBolt    className="icons-svg" />
                <Text>NFT</Text>
              </Link>
            </li> */}

           

            <li>
              <Link to="/privacypolicy" className={`sidebar-link ${pathName.pathname === "/privacypolicy" ? "active" : ""}`} title="Privacy&Policy">
                <FaFileAlt className="icons-svg" />
                <Text>Privacy & Policy</Text>
              </Link>
            </li>

            <li>
              <Link to="/termsandconditions" className={`sidebar-link ${pathName.pathname === "/termsandconditions" ? "active" : ""}`} title="Terms&Conditions">
                <FaFileSignature className="icons-svg" />
                <Text>Terms & Conditions</Text>
              </Link>
            </li>
            <li>
              <Link to="/faq" className={`sidebar-link ${pathName.pathname === "/faq" ? "active" : ""}`} title="Faq">
                <FaQuestionCircle className="icons-svg" />
                <Text> FAQ</Text>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
